var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('settings-layout',{attrs:{"items":_vm.masterItems,"disableList":_vm.fetching,"headerTitle":_vm.$t('masters'),"windowRouteName":"masterWindow"}},[_c('master-window',{on:{"fetching":_vm.fetchingData}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }